import type { StrokeProps, Shadow } from '@/common/components/FileCenterProvider';
import { RGBA } from '@/common/constants/interfaces';

export interface FontSpecialEffectProps {
    fontColorProp: RGBA;
    strokeProp?: StrokeProps;
    shadowProp?: Shadow;
}

const fontSpecialEffectsConfig: FontSpecialEffectProps[] = [
    {
        fontColorProp: RGBA.fromHex('#0000FF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FF318D'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#7BC2FF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FF0000'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#000000'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFDE00'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        shadowProp: {
            shadowColor: RGBA.fromHex('#000000'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFDA00'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#000000'),
            strokeWidth: 2,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FE2F51'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFB608'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#000000'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#5FC34B'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        shadowProp: {
            shadowColor: RGBA.fromHex('rgba(0, 0, 0, 0.5)'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFDBDD'),
        shadowProp: {
            shadowColor: RGBA.fromHex('#FD8989'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#000000'),
        shadowProp: {
            shadowColor: RGBA.fromHex('#FFB507'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFDA08'),
        shadowProp: {
            shadowColor: RGBA.fromHex('#EF4913'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        shadowProp: {
            shadowColor: RGBA.fromHex('#0BFFDF'),
            offsetX: 5,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FB35DD'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFE900'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#F21D36'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#000000'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#5FC34B'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FF35A7'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#0FD7F5'),
            strokeWidth: 3,
        },
        shadowProp: {
            shadowColor: RGBA.fromHex('#0FD7F5'),
            offsetX: 1,
            offsetY: 1,
            blur: 15,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#000000'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 3,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FF693B'),
            strokeWidth: 6,
        },
        shadowProp: {
            shadowColor: RGBA.fromHex('#CD2701'),
            offsetX: 4,
            offsetY: 6,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FDE959'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#4933FF'),
            strokeWidth: 5,
        },
        shadowProp: {
            shadowColor: RGBA.fromHex('#A52DC5'),
            offsetX: 3,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FF7235'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFFFFF'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FF35A7'),
            strokeWidth: 4,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#FFFFFF'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#415FF7'),
            strokeWidth: 5,
        },
        shadowProp: {
            shadowColor: RGBA.fromHex('#1343D3'),
            offsetX: 3,
            offsetY: 5,
            blur: 0,
        },
    },
    {
        fontColorProp: RGBA.fromHex('#F21E37'),
        strokeProp: {
            strokeColor: RGBA.fromHex('#FFD735'),
            strokeWidth: 5,
        },
        shadowProp: {
            shadowColor: RGBA.fromHex('#FFD735'),
            offsetX: 3,
            offsetY: 5,
            blur: 0,
        },
    },
];

export { fontSpecialEffectsConfig };